import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { UtilitySidebarComponent } from './utility-sidebar/utility-sidebar.component';

@Component({
  selector: 'app-utility-layout',
  standalone: true,
  imports: [RouterOutlet, UtilitySidebarComponent],
  template: `
    <div class="utility-app-layout">
      <div class="utility-app-sidebar-container">
        <app-utility-sidebar class="utility-app-sidebar"></app-utility-sidebar>
      </div>
      <div class="utility-app-content">
        <router-outlet></router-outlet>
      </div>
    </div>
  `,
  styles: `
    .utility-app-layout {
      display: flex;
      height: calc(100vh - 65px);
      width: 100%;
      position: relative;
    }
    
    .utility-app-sidebar-container {
      width: 260px;
      height: 100%;
      box-shadow: var(--sidebar-layout-shadow);
      overflow: hidden;
    }
    
    .utility-app-sidebar {
      display: block;
      height: 100%;
      overflow: hidden;
    }
    
    .utility-app-content {
      flex: 1;
      height: 100%;
      overflow-y: auto;
      overflow-x: hidden;
    }
  `
})
export class UtilityLayoutComponent {}
